module.exports = "<tr> <td>{%- sku %}</td> <td>{%= service %}</td> <td class=q-text-right>{%- quantity %}</td> <td class=q-text-right>{%= cost %}</td> </tr>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/asns/detailPageLookupHTML/serviceLookupBody.html
// module id = 1241
// module chunks = 1